import type { FilterState } from '../services/FilterService';

export const useViewStateStore = defineStore('plugin:viewstate', () =>
{
    const key = ref('');
    const filters = ref<Record<string, any>>({});
    const pager = ref<Record<string, any>>({});
    const columns = ref<Record<string, any>>({});

    function getFilters(key: string): FilterState
    {
        return filters.value[key] || {
            activeTemplate: {
                name: '',
                id: 0
            },
            visibleFilters: false
        };
    }

    function setFilters(key: string, item: FilterState): void
    {
        filters.value[key] = item;
    }

    function getPager(key: string): PagerContract
    {
        return pager.value[key];
    }

    function setPager(key: string, item: PagerContract): void
    {
        pager.value[key] = item;
    }

    function getColumns(key: string): Columns
    {
        return columns.value[key] || {
            visible: {},
            positions: {}
        };
    }

    function setColumns(key: string, item: Columns): void
    {
        columns.value[key] = item;
    }

    return { key, getFilters, setFilters, getPager, setPager, getColumns, setColumns };
});
